"use strict";
/*
 * This file is part of ORY Editor.
 *
 * ORY Editor is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * ORY Editor is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with ORY Editor.  If not, see <http://www.gnu.org/licenses/>.
 *
 * @license LGPL-3.0
 * @copyright 2016-2018 Aeneas Rekkas
 * @author Aeneas Rekkas <aeneas+oss@aeneas.io>
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var computeOrder = function (_a) {
    var rows = _a.rows, cells = _a.cells, _b = _a.content, _c = (_b === void 0 ? {} : _b).plugin, _d = (_c === void 0 ? {} : _c).name, name = _d === void 0 ? '' : _d, id = _a.id;
    return [
        [
            {
                id: id,
                isLeaf: Boolean(name),
            },
        ]
    ].concat((rows || []).map(computeOrder), (cells || []).map(computeOrder)).reduce(function (p, n) { return p.concat(n); }, []);
};
// tslint:disable-next-line:no-any
exports.cellOrder = function (os) {
    return os
        .map(computeOrder)
        // tslint:disable-next-line:no-any
        .reduce(function (p, n) { return p.concat(n); }, []);
};
//# sourceMappingURL=order.js.map